window.LoopService = window.LoopService || {};

window.LoopService.Onetime = {
  /**
   * Add a one-time product to the next order
   */
  add: async ({ subscriptionId, variantId, quantity, attributes = [] }) => {
    try {
      if (!subscriptionId || !variantId) {
        throw new Error("addOnetime: missing required parameters");
      }

      const body = {
        shopifyCustomerId: window.Shopify?.customerId?.toString(),
        subscriptionId: +subscriptionId,
        addressId: window.Shopify?.shippingAddress?.id,
        orderDate: new Date().toISOString(),
        externalVariantId: variantId,
        quantity: Number(quantity || 1),
        shopDomain: window.Shopify?.shopDomain,
      };

      if (attributes && Array.isArray(attributes) && attributes.length) {
        body.attributes = attributes;
      }

      const baseUrl = window.LoopService.Base.getDigitalOceanBaseUrl();
      const url = `${baseUrl}/loop/wallet/onetimes`;

      const response = await window.LoopService.Base.makeAuthenticatedRequest(
        url,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        }
      );

      return await response.json();
    } catch (error) {
      console.error("Add onetime product failed:", error);
      throw error;
    }
  },

  /**
   * Update quantity of an existing one-time line
   */
  updateQuantity: async ({
    subscriptionId,
    externalVariantId,
    lineId,
    quantity,
  }) => {
    try {
      if (!subscriptionId || !lineId || !quantity) {
        throw new Error("updateOnetimeQuantity: missing required parameters");
      }

      const body = {
        chargeId: subscriptionId,
        externalVariantId,
        onetimesId: lineId,
        quantity,
        shopDomain: window.Shopify?.shopDomain,
        shopifyCustomerId: window.Shopify?.customerId?.toString(),
      };

      const baseUrl = window.LoopService.Base.getDigitalOceanBaseUrl();
      const url = `${baseUrl}/loop/wallet/onetimes`;

      const response = await window.LoopService.Base.makeAuthenticatedRequest(
        url,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        }
      );

      return await response.json();
    } catch (error) {
      console.error("Update onetime quantity failed:", error);
      throw error;
    }
  },

  /**
   * Remove a one-time line from the next order
   */
  remove: async ({ subscriptionId, lineId }) => {
    try {
      if (!subscriptionId || !lineId) {
        throw new Error("removeOnetime: missing required parameters");
      }

      const body = {
        chargeId: subscriptionId,
        onetimesId: lineId,
        shopDomain: window.Shopify?.shopDomain,
        shopifyCustomerId: window.Shopify?.customerId?.toString(),
      };

      const baseUrl = window.LoopService.Base.getDigitalOceanBaseUrl();
      const url = `${baseUrl}/loop/wallet/onetimes/${lineId}`;

      await window.LoopService.Base.makeAuthenticatedRequest(url, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      return true;
    } catch (error) {
      console.error("Remove onetime product failed:", error);
      throw error;
    }
  },
};
